import backend from '@common/backend';

const BASE = '/meets';

export const getMeets = (query: any) =>
	backend.get(`${BASE}`, {
		params: query,
	});

export const createMeet = async (data: any) => backend.post(`${BASE}`, data);

export const createMeets = async (data: any[]) => backend.post(`${BASE}/bulk`, data);

export const updateMeet = async (id: number, data: any) => backend.put(`${BASE}/${id}`, data);

export const getMeetLessons = (studentId: any, groupId: number, programId?: number) =>
	backend.get(`${BASE}/programLessons/${studentId}/${groupId}`, {
		...(programId && { params: { program_id: programId } }),
	});

export const removeMeet = (meetId: number) => backend.delete(`${BASE}/${meetId}`);
